import { ChartOptions, TooltipItem } from 'chart.js'
import React from 'react'
import { Pie } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'

import { IOccupancyRateReport } from '../Client/IOccupancyRateReport'

import Style from './style.scss'

type Props = {
  avatar: string
  firstName: string
  lastName: string
  report?: IOccupancyRateReport
}

export const StatisticCard = ({
  avatar,
  firstName,
  lastName,
  report,
}: Props) => {
  const { t } = useTranslation()
  let datasetData = [0, 0, 0]

  const options: ChartOptions<'pie'> = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'right',
      },
      tooltip: {
        callbacks: {
          label: (context: TooltipItem<'pie'>): string => {
            const [wholeNumber, decimal] = context.parsed.toString().split('.')
            const minutes = Math.round(Number(decimal) * 6)
            const label = `${context.label}: ${wholeNumber}h ${minutes}m`
            return label
          },
        },
      },
    },
  }

  if (report) {
    let unoccupiedMinutes =
      report.workingMinutes - report.appointmentMinutes - report.blockedMinutes
    if (unoccupiedMinutes < 0) {
      unoccupiedMinutes = 0
    }

    const totalMinutes =
      unoccupiedMinutes + report.appointmentMinutes + report.blockedMinutes

    if (0 < totalMinutes) {
      datasetData = [
        unoccupiedMinutes / 60,
        report.appointmentMinutes / 60,
        report.blockedMinutes / 60,
      ]
    }
  }

  const data = {
    labels: [t('Unoccupied'), t('AppointmentsReport'), t('Blocked')],
    datasets: [
      {
        backgroundColor: ['#005cdb', '#dd019a', '#d24444'],
        hoverBackgroundColor: ['#005cdb', '#dd019a', '#d24444'],
        data: datasetData,
      },
    ],
  }

  let profileInitials

  if (firstName && lastName)
    profileInitials = firstName.charAt(0) + lastName.charAt(0)

  return (
    <div className={Style.card}>
      <div>
        <div className={Style.cardBody}>
          {report ? (
            <Pie data={data} options={options} />
          ) : (
            <p className={Style.noDataText}>
              {t('No data available for this user')}
            </p>
          )}
        </div>
        <div className={Style.cardContent}>
          {avatar ? (
            <img
              className={Style.avatarImage}
              src={`${avatar}&w=50&h=50&fit=crop`}
            />
          ) : (
            <div className={Style.avatarCredentials}>{profileInitials}</div>
          )}

          <hr className={Style.horizontalLine} />
          <h2 className={Style.cardTitle}>
            {firstName} {lastName}
          </h2>
        </div>
      </div>
    </div>
  )
}
